import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ClrIcon } from '@clr/angular';
import { TablePrettyPrintPipe } from 'src/app/pipes/tablePrettyPrint.pipe';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-dg-cell',
  template: `
    <div class="name-cell">
      @if (data() === true) {
        <cds-icon data-testid="bool-true" shape="success-standard" solid="true" style="fill: #2ec0ff" />
      } @else if (data() === false) {
        <cds-icon data-testid="bool-false" shape="circle" />
      } @else {
        {{ data() | tablePrettyPrint: col() }}
      }
    </div>
  `,
  host: {
    'data-testid': 'app-dg-cell',
    class: 'w-100-p'
  },
  imports: [ClrIcon, TablePrettyPrintPipe],
})
export class TextBoolDgCell {
  protected readonly data = input.required<unknown>();
  protected readonly col = input<string>();
}
